import * as $ from 'jquery';

import Debouncer from '../../lib/Debouncer';
import DetectBrowser from '../../lib/DetectBrowser';
import ViewportTracker from '../../lib/ViewportTracker';

// Load to ensure our easing functions are registered with jQuery
import '../../lib/AnimationEasing';

/*
NOTE: This is the use in the index.ts file
import MainMenu from './component/MainMenu';
new MainMenu({
	menu 				: '#menu',
	menuTarget 			: '.menu__inner',
	nodeTarget 			: '.childWrap',
	nodeTrigger 			: '.node--hasChild > a',
	headTarget 			: '.childWrap__heading',
	triggers 			: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
	triggerEvent 		: 'click',
	collapsable: {
		duration			: 400
	},
	styleClass: {
		setup 			: 'hasMenuSetup',
		menuOpen 		: 'hasMenuOpen',
		nodeOpen 		: 'isOpen',
		backWrap 		: 'childWrap__back'
	}
});
 * */
export interface MainMenuConfig {
	[key: string]: any
}
export default class MainMenu {
	private menuActive = false;
	private animationUnsupported = false;
	private $menu: JQuery;
	private $menuTarget: JQuery;
	private $nodeTriggers: JQuery;
	private isOpen = false;

	constructor(private config: MainMenuConfig) {
		let browserInfo = DetectBrowser.getInfo();

		this.animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;

		this.$menu = $(config.menu);
		this.$menuTarget = this.$menu.find(config.menuTarget);
		this.$nodeTriggers = this.$menu.find(config.nodeTrigger);

		const resizeDebouncer = new Debouncer(() => {
			this.syncMobileMenuToViewport();
		});
		window.addEventListener('resize', resizeDebouncer.run);

		this.syncMobileMenuToViewport();

		this.$menu.addClass(this.config.styleClass.setup);

		// Open current and close the other ones
		this.openNode(this.$nodeTriggers.not('.isActive').parent(), false);
		this.openNode(this.$nodeTriggers.filter('.isActive').parent(), true);

		// Open/close menu handler
		$(this.config.triggers).on(this.config.triggerEvent, (event) => {
			if (this.menuActive === false) {
				return;
			}
			event.preventDefault();
			this.isOpen
				? this.closeMenu()
				: this.openMenu();
		});

		// Close menu when clicking on anchor link that is on current page (needed for Belle Amie)
		$('.node--isActive a[href*="#"]').on(this.config.triggerEvent, (event) => {
			this.closeMenu();
		});

		// Open/close node handler
		this.$menu.on('click.mobileMenu', this.config.nodeTrigger, (event) => {
			if (this.menuActive === false) {
				return;
			}
			event.preventDefault();

			var $anchor = event.target.tagName !== 'A' ? $(event.target).parent('A') : $(event.target);
			var $listItem = $anchor.parent('li');

			this.openNode($listItem, !this.isNodeOpen($listItem));
		});
	}

	private syncMobileMenuToViewport() {
		// Turn mobile menu on/off based on size
		if (ViewportTracker.below('mobileMenu')) {
			this.turnOn();
		} else {
			this.turnOff();
		}
	}

	turnOn() {
		if (this.menuActive === false) {
			this.menuActive = true;
		}
	}
	turnOff() {
		this.menuActive = false;
		this.isOpen = false;
		/* BACKLOG:
		 * What about deregistering event handlers?
		 * */
	}

	private openMenu(): void {
		this.$menu.addClass(this.config.styleClass.menuOpen);
		document.documentElement.classList.add(this.config.styleClass.menuOpen);

		this.isOpen = true;
	}

	private closeMenu(): void {
		this.$menu.removeClass(this.config.styleClass.menuOpen);
		document.documentElement.classList.remove(this.config.styleClass.menuOpen);

		this.isOpen = false;
	}

	isNodeOpen($listItem: JQuery) {
		return $listItem.hasClass(this.config.styleClass.nodeOpen);
	}

	openNode($listItem: JQuery, open: boolean) {
		if (this.menuActive === false) {
			return;
		}

		if (this.config.onNodeChange !== undefined) {
			var ifContinue = this.config.onNodeChange($listItem, open);
			if (ifContinue === false) {
				return;
			}
		}

		if (this.config.hideSiblingMenuItems !== undefined) {
			if ($listItem.filter(this.config.hideSiblingMenuItems).length > 0) {
				this.slideToggle($listItem.siblings(this.config.hideSiblingMenuItems), this.config.collapsable.duration, 'easeOutExpo', !open);
			}
		}

		this.openNodeHelper($listItem, open);
	}

	openNodeHelper($listItem: JQuery, open: boolean) {
		$listItem.toggleClass(this.config.styleClass.nodeOpen, open);

		if (this.config.collapsable !== undefined) {
			var $elementSlide = $listItem.children('div');

			var duration = (this.animationUnsupported ? 0 : this.config.collapsable.duration);
			this.slideToggle($elementSlide, duration, 'easeOutExpo', open);
		}
	}

	slideToggle($element: JQuery, duration: number, ease: string, open: boolean) {
		$element.stop();
		if (open === true) {
			$element.slideDown(duration, ease);
		} else {
			$element.slideUp(duration, ease);
		}
	}
}